import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { ImovelSimulationDTO } from '../dtos/imovel-simulation.dto';
import { VeiculoSimulationDTO } from '../dtos/veiculo-simulation.dto';
import { DuvidaDTO } from '../dtos/duvida.dto';

declare global {
  interface Window {
    dataLayer: any[];
  }
}

@Injectable({
  providedIn: 'root'
})
export class SimulationApiService {

  private readonly apiUrl = 'https://form-handler.tatikka.workers.dev/';

  constructor(private http: HttpClient) { }

  sendImovelSimulation(data: ImovelSimulationDTO): Observable<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    const payload = {
      ...data,
      formId: "porto-bank-consorcio_Simulacao-Imovel"
    };

    return this.http.post(this.apiUrl, payload, { headers }).pipe(
      tap(() => {
        this.trackSuccess('simulacao_imovel', 'Imovel');
      })
    );
  }

  sendVeiculoSimulation(data: VeiculoSimulationDTO): Observable<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    const payload = {
      ...data,
      formId: "porto-bank-consorcio_Simulacao-Veiculo"
    };

    return this.http.post(this.apiUrl, payload, { headers }).pipe(
      tap(() => {
        this.trackSuccess('simulacao_veiculo', 'Veiculo');
      })
    );
  }

  sendDuvida(data: DuvidaDTO): Observable<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    const payload = {
      ...data,
      formId: "porto-bank-consorcio_ContatoDuvida"
    };

    return this.http.post(this.apiUrl, payload, { headers }).pipe(
      tap(() => {
        this.trackSuccess('contato_duvida', 'Duvida');
      })
    );
  }

  private trackSuccess(eventName: string, category: string) {
    if (typeof window !== 'undefined') {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'form_submit_success',
        form_name: eventName,
        form_category: category
      });

      window.dataLayer.push({
        event: 'generate_lead',
        currency: 'BRL',
        value: 0
      });
    }
  }
}